'use client';

import { useIsMobile } from '@/components/hooks/use-mobile';
import * as Tooltip from '@radix-ui/react-tooltip';
import { Image } from '../image/image';

import styles from '../pricing-card/pricing-card.module.scss';

export const TooltipInfo = ({ text }: { text: string }) => {
  const isMobile = useIsMobile();

  //! Can we create standalone tooltip CSS file and use CSS rather than JS to hide tooltip which would then allow us to make this a server component?!

  return (
    !isMobile && (
      <Tooltip.Provider delayDuration={0}>
        <Tooltip.Root>
          <Tooltip.Trigger asChild>
            <Image
              className={styles.component_content_content_features_feature_extraIcons_icon}
              src="/images/temp/Icon-info.svg"
              alt="Additional Info"
              width={16}
              height={16}
            />
          </Tooltip.Trigger>
          <Tooltip.Portal>
            <Tooltip.Content className={styles.tooltip} side="top">
              {text}
            </Tooltip.Content>
          </Tooltip.Portal>
        </Tooltip.Root>
      </Tooltip.Provider>
    )
  );
};
